<template>
    <div class="flex items-center justify-center w-full md:w-[50vw] h-[200px] p-5 bg-white rounded text-5xl text-center">
        Not Found
    </div>
</template>